export const actionsMenuStyle = {
	options: {
		width:'100',
		maxWidth: '200px',
	},

	option: {
		padding: '8px 16px',
		cursor: 'pointer',

		'&:hover': {
			background: 'var(--background-grey-op-50-1)',
		},
		'&:last-child': {
			color: 'var(--error-500)',
		},
	},

	activeButton: {
		'& svg path': {
			fill: 'var(--primary-500)',
		},
	},

	button: {
		svg: {
			fill: 'var(--neutral-300)',
		},
	},

	disabledMenuItem: {
		color: 'var(--neutral-300)',
		cursor: 'default',
		// display: 'none',
	},
};
